<template>
  <div class="Do">
    <div class="doMain">
      <div class="doTitle">
        <!--        <div class="tit">{{ $t("navbar.index") }}</div>-->
        <div class="sub">
          <!-- <p>{{ $t("DAO.DONetwork") }}</p> -->
          <li>{{ $t("navbar.join[0]") }}</li>
          <li>{{ $t("navbar.join[1]") }}</li>
        </div>
      </div>
      <div class="content clearfix">
        <div class="dec">
          <img src="../../assets/pc/Decentralized.svg" alt="" />
          <div class="decTitle">{{ $t("home.decentralized") }}</div>
          <div class="intro">{{ $t("home.high") }}</div>
        </div>
        <div class="dec">
          <img src="../../assets/pc/Sustainable scalability 1.svg" alt="" />
          <div class="decTitle">{{ $t("home.sustainable") }}</div>
          <div class="intro">{{ $t("home.Dao") }}</div>
        </div>
        <div class="dec">
          <img src="../../assets/pc/Diversified.svg" alt="" />
          <div class="decTitle">{{ $t("home.diversified") }}</div>
          <div class="intro">{{ $t("home.protocol") }}</div>
        </div>
        <div class="dec">
          <img src="../../assets/pc/Dual-protocol.svg" alt="" />
          <div class="decTitle">{{ $t("home.dual") }}</div>
          <div class="intro">{{ $t("home.WASM") }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {},
  mounted() {},
  destroyed() {},
  methods: {},
};
</script>
<style lang="less">
.clearfix:after {
  /*伪元素是行内元素 正常浏览器清除浮动方法*/
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.clearfix {
  *zoom: 1;
}
.w1352 {
  width: 1200px;
  margin: 0 auto;
}
.w1300 {
  width: 67%;
  margin: 0 auto;
}
@keyframes showBottom {
  to {
    opacity: 1;
    transform: translateY(0px);
  }
}
@keyframes hideBottom {
  to {
    opacity: 0;
    transform: translateY(100px);
  }
}
</style>
<style lang="less" scoped>
@keyframes showLeft {
  to {
    opacity: 1;
    transform: translateX(0px);
  }
}
@keyframes showRight {
  to {
    opacity: 1;
    transform: translateX(0px);
  }
}
@keyframes hideLeft {
  to {
    opacity: 0;
    transform: translateX(-100px);
  }
}
@keyframes hideRight {
  to {
    opacity: 0;
    transform: translateX(100px);
  }
}
@keyframes scaleUp-animation {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.25);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes scaleDown-animation {
  0% {
    transform: scale(1.25);
  }
  50% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.25);
  }
}
.scale {
}
.scale :hover {
  transform: rotate(7deg);
  -ms-transform: rotate(7deg); /* IE 9 */
  -moz-transform: rotate(7deg); /* Firefox */
  -webkit-transform: rotate(7deg); /* Safari 和 Chrome */
  -o-transform: rotate(7deg); /* Opera */
  color: red;
}
.Do {
  text-align: center;
  margin-top: -480px;
  width: 100%;
  color: #000000;
  background: #f5f6f9;
  // opacity: 0;
  .doMain {
    text-align: center;
  }
}
li {
  list-style: none;
}
.content {
  width: 1200px;
  margin-top: 200px;
  display: inline-block;
}
.tit {
  height: 36px;
  font-size: 24px;
  font-weight: 500;
  font-family: Poppins-Medium, Poppins;
  color: #000000;
  line-height: 28px;
  -webkit-background-clip: text;
  margin-bottom: 16px;
}
.sub {
  text-align: center;
  font-size: 60px;
  font-weight: 900;
  font-family: Poppins-Medium, Poppins;
  color: #000000;
  line-height: 77px;
  -webkit-background-clip: text;
}
.dec {
  float: left;
  width: 275px;
  height: 440px;
  margin-right: 25px;
  background: #f2f5f9;
  border-radius: 15px 15px 15px 15px;
  opacity: 1;
  text-align: center;
  img {
    width: 200px;
    height: 130px;
    margin-top: 26px;
  }
  .decTitle {
    height: 31px;
    font-size: 18px;
    font-family: Poppins-SemiBold, Poppins;
    font-weight: 600;
    color: #1a1a2c;
    line-height: 31px;
    -webkit-background-clip: text;
  }
  .intro {
    margin-top: 10px;
    margin-left: 25.5px;
    width: 224px;
    font-size: 14px;
    font-family: Poppins-Regular, Poppins;
    font-weight: 400;
    color: #888a9b;
    line-height: 24px;
    -webkit-background-clip: text;
  }
}
.dec:hover {
  background: #ffffff;
}
.sub {
  p {
    font-size: 24px;
    font-family: Poppins-Medium, Poppins;
    font-weight: 500;
    color: #000000;
    line-height: 28px;
    -webkit-background-clip: text;
    margin-bottom:16px;
  }
}
</style>
